import { useUser } from './useUser';

export interface UseGuestModeResult {
  isGuest: boolean;
  isAuthenticated: boolean;
  loading: boolean;
}

/**
 * Hook to detect if the current user is in guest mode or authenticated
 * @returns Object with isGuest, isAuthenticated, and loading flags
 */
export function useGuestMode(): UseGuestModeResult {
  const { user, loading } = useUser();

  return {
    isGuest: !loading && user === null,
    isAuthenticated: !loading && user !== null,
    loading,
  };
}
